import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';
import { Header2, Loader } from '@ubeya/shared-web/components';
import useEmployeeComments from '@ubeya/shared/hooks/account/useEmployeeComments';
import { SORT_BY_DATE_AND_TIME } from '@ubeya/shared/utils/sorting';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { AccordionSummaryContainer } from '@ubeya/shared-web/components/Accordion/Accordion';
import { RootContainer, RootWrapper } from '../styled';
import Comment from './Comment';
import AddCommentSection from './AddCommentSection';

const Wrapper = styled.div`
  overflow: auto;
`;

const EmployeeComment = ({ data: employeeData }) => {
  const { t, accountId } = useContext(ConfigContext);
  const { id: employeeId, email: employeeEmail } = employeeData || {};

  const { isLoading, data, deleteComment, addComment, sendCommentEmail } = useEmployeeComments({
    employeeId
  });

  const timeSorter = SORT_BY_DATE_AND_TIME('createdAt');

  const sortedData = useMemo(() => data.sort((a, b) => timeSorter(b, a)), [data, timeSorter]);

  const handleSubmit = useCallback(
    async ({ comment, type, filePath, attachmentName }) => {
      await addComment({ comment, typeId: type, filePath, attachmentName });
    },
    [addComment]
  );

  return (
    <RootWrapper>
      <RootContainer>
        <AccordionSummaryContainer>
          <Header2> {t('comments')} </Header2>
        </AccordionSummaryContainer>

        <AddCommentSection onSubmit={handleSubmit} />

        <Wrapper>
          {(sortedData || []).map(({ id, comment, admin, type, createdAt, file, emailSentAt }) => (
            <Comment
              key={id}
              id={id}
              t={t}
              comment={comment}
              createdAt={createdAt}
              firstName={admin?.firstName || ''}
              lastName={admin?.lastName || ''}
              type={type}
              file={file}
              emailSentAt={emailSentAt}
              employeeEmail={employeeEmail}
              accountId={accountId}
              deleteComment={deleteComment}
              sendCommentEmail={sendCommentEmail}
            />
          ))}
        </Wrapper>

        {isLoading && <Loader />}
      </RootContainer>
    </RootWrapper>
  );
};

export default React.memo(EmployeeComment);
